import React from 'react';
import { Page, Text, View, Image } from '@react-pdf/renderer';

import hgsdLogo from '../../black-textHGSDlogo400px.png';
import ftBendLogo from '../../fbsd_logo_clr_rgb.png';

export default function AppendixI({ styles, data, year, month, footer }) {
  return (
    <Page size='A4'>
      <View style={styles.pageTitle}>
        <Text style={styles.pageTitle}></Text>
      </View>
      <View style={styles.document}>
        <View style={[styles.row, styles.borderBottom]}>
          <Image
            src={window.config.client === 'FT-BEND' ? ftBendLogo : hgsdLogo}
            style={styles.logo}
          />
          <Text style={styles.logoLabel}>Appendix I</Text>
        </View>
        <View style={[styles.row, styles.borderBottom]}>
          <Text style={styles.logo} />
          <Text style={styles.logoLabel}>New Wells Report</Text>
        </View>
        <View style={styles.section}>
          <View style={styles.row}>
            <Text style={styles.column}>PERMIT NUMBER</Text>
          </View>
          <View style={[styles.row, styles.borderBottom]}>
            <Text style={styles.column}>PERMITTEE</Text>
            <Text style={styles.column}>WELL</Text>
            <Text style={styles.column}>ALLOCATION (MGY)</Text>
            <Text style={styles.column}>AREA</Text>
            <Text style={styles.column}>AGGREGATE</Text>
            <Text style={styles.column}>DIAM. (in.)</Text>
          </View>
          {data.length === 0 ? (
            <View style={styles.column}>
              <Text>NONE</Text>
            </View>
          ) : null}
          {data.map((permit) => (
            <>
              <View style={styles.row}>
                <Text style={styles.column}>{permit.CASE_NUMBER}</Text>
              </View>
              <View style={styles.row}>
                <Text style={styles.column}>{permit.Permittee}</Text>
                <Text style={styles.column}>{permit.WellNo}</Text>
                <Text style={styles.column}>{permit.Allocation}</Text>
                <Text style={styles.column}>{permit.AREA}</Text>
                <Text style={styles.column}>
                  {permit.NumWellsInAgg > 1 ? 'Yes' : 'No'}
                </Text>
                <Text style={styles.column}>{permit.CASINGINCH}</Text>
              </View>
            </>
          ))}
        </View>
      </View>
      <View fixed style={styles.footer}>
        {/* <Text style={styles.data}>{footer}</Text> */}
        <Text
          style={styles.data}
          render={({ pageNumber, totalPages }) =>
            `${footer} (${pageNumber}/${totalPages})`
          }
        />
      </View>
    </Page>
  );
}
